@if (show) {

  <div class="voice-panel">

    <!-- Header -->
    <div class="voice-header">
      <h3>Voz do assistente</h3>
      <button class="voice-icon-btn" (click)="fechar()" aria-label="Fechar">
        <span class="material-symbols-outlined">close</span>
      </button>
    </div>

    <hr class="voice-divider" />

    <div class="voice-body">

      <!-- Status + liga/desliga -->
      <div class="voice-status-row" [ngClass]="'st-' + status" [class.st-gravando]="gravando">
        <span class="voice-status-icon material-symbols-outlined">{{ statusIcon }}</span>
        <span class="voice-status-text">{{ statusLabel }}</span>
        <button class="voice-toggle" [class.on]="ligado" (click)="toggle()"
          [disabled]="status === 'sem-suporte'">
          {{ ligado ? 'Desligar' : 'Ativar' }}
        </button>
      </div>

      <!-- Medidor de volume ao vivo (prova de que o microfone capta) -->
      <div class="voice-meter" [class.ativo]="ligado" [class.gravando]="gravando">
        <div class="voice-meter-fill" [style.width.%]="nivel * 100"></div>
      </div>
      <span class="voice-hint">
        @if (ligado) {
          Fale normalmente — eu detecto quando você termina e envio. Depois é só continuar a conversa.
        } @else {
          Ative o modo conversa e fale à vontade. Sem precisar de "Oi ERP".
        }
      </span>

      <!-- Fala perdida por envio concorrente: sinal explícito, nunca descarte silencioso -->
      @if (falasIgnoradas > 0) {
        <div class="voice-aviso">
          <span class="material-symbols-outlined">info</span>
          <span>
            {{ falasIgnoradas }}
            {{ falasIgnoradas === 1 ? 'fala não foi enviada' : 'falas não foram enviadas' }}
            porque eu ainda estava respondendo a anterior. Espere a resposta e repita.
          </span>
        </div>
      }

      <!-- Erro / permissão -->
      @if (erro) {
        <div class="voice-erro">
          <span class="material-symbols-outlined">error</span>
          <span>{{ erro }}</span>
        </div>
      }

      <!-- Seletor de microfone -->
      <label class="voice-field">
        <span class="voice-field-label">Microfone</span>
        <select class="voice-select" [value]="dispositivoSelecionado" (change)="onDeviceChange($event)">
          <option value="">Padrão do sistema</option>
          @for (d of dispositivos; track d.deviceId; let i = $index) {
            <option [value]="d.deviceId">{{ rotuloDispositivo(d, i) }}</option>
          }
        </select>
      </label>

      <!-- Diagnóstico técnico: piso de ruído + limiar do VAD e log dos últimos eventos.
           Foi este painel que, no passado, evidenciou que a rede corporativa bloqueia a
           Web Speech API — e é ele que permite o smoke test manual do VAD novo. -->
      @if (ligado || eventos.length) {
        <details class="voice-diag">
          <summary>Diagnóstico técnico</summary>
          <div class="voice-diag-metrics">
            <span>Nível atual: {{ (nivel * 100).toFixed(0) }}%</span>
            <span>Piso de ruído: {{ (noiseFloor * 100).toFixed(1) }}%</span>
            <span>Limiar de disparo: {{ (limiarInicio * 100).toFixed(1) }}%</span>
          </div>
          @if (eventos.length) {
            <ul>
              @for (ev of eventos; track $index) {
                <li>{{ ev }}</li>
              }
            </ul>
          } @else {
            <p class="voice-diag-vazio">Nenhum evento do VAD ainda — fale para ver os disparos.</p>
          }
        </details>
      }

    </div>

  </div>

  <div class="voice-backdrop" (click)="fechar()"></div>
}
